/** Embed snippets for an organisation's key (iframe, script loader, WordPress). */
import { publicApiOrigin } from "../config";

/** The hosted calculator page for a key. The API serves it with `frame-ancestors` = the key's allowed origins (plus
 * localhost for test keys), so it only shows framed on those sites. No Google key is needed. */
export function widgetSrc(key: string): string {
  return `${publicApiOrigin()}/api/public/embed/${encodeURIComponent(key)}`;
}

export function iframeSnippet(key: string): string {
  return [
    `<iframe src="${widgetSrc(key)}"`,
    `        style="width:100%;height:1100px;border:0" loading="lazy" title="Solar quote"></iframe>`,
  ].join("\n");
}

export const wordpressShortcode = "[solar_quote_pro]";
export const wordpressModalShortcode = '[solar_quote_pro modal="1"]';

export function wordpressSettings(key: string): string {
  return [`Embed key:     ${key}`, `API base URL:  ${publicApiOrigin()}`].join("\n");
}

/** `https://www.example.com/path` → `https://www.example.com`; bare domains get https. */
export function normalizeOrigin(raw: string): string {
  let value = raw.trim().toLowerCase();
  if (!value) return "";
  if (!/^https?:\/\//.test(value)) value = `https://${value}`;
  const match = value.match(/^(https?:\/\/(\*\.)?[^/?#]+)/);
  return match ? match[1] : value;
}

const ORIGIN = /^https?:\/\/(\*\.)?[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)*(:[0-9]{1,5})?$/;
export function originProblem(origin: string): string | null {
  return ORIGIN.test(origin) ? null : `“${origin}” is not a website address like https://www.example.com`;
}
